'use strict';
const angular = require('angular');
const {element} = angular;

module.exports.directive = [
  '$timeout',
  '$window',
  limitPersonnelDirective];

function limitPersonnelDirective($timeout, $window) {
  return {
    restrict: 'AEC',
    scope: true,
    link: function ($scope, $element, $attrs) {

      $timeout(function () {
        var w = $element.prop('offsetWidth');

        var browserWidth = element($window);
        browserWidth.bind("resize", function (e) {
          $timeout(function () {
            w = $element.prop('offsetWidth');
            $scope.$apply();
            limitItems();
          }, 300);

        });

        var limitItems = function () {
          var itemsAcross = Math.floor(w / parseInt($scope.teamsEdit.personWidth));
          //TODO this needs to set the .showCount property in the parent controller and the limitTo in the template needs to update
          $scope.teamsEdit.showCount = itemsAcross;
        };

        limitItems();
      }, 0);
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/personnel/directives/LimitPersonnelDirective.js